import React, { useRef, useState } from 'react';
import { User, UserRole } from '../../types';
import './TopBar.css';
import { useLanguage } from '../../contexts/LanguageContext';
import NotificationBell from '../Notification/NotificationBell';

interface TopBarProps {
    toggleSidebar: () => void;
    currentUser: User | null;
}

const TopBar: React.FC<TopBarProps> = ({ toggleSidebar, currentUser }) => {
    const { language, setLanguage, availableLanguages, t } = useLanguage();

    // Helper to get user role text (duplicated from Sidebar, could be util)
    const getUserRoleText = (role: UserRole | string) => {
        switch (role) {
            case UserRole.OWNER:
                return t('roles.owner');
            case UserRole.MANAGER:
                return t('roles.manager');
            case UserRole.STAFF:
                return t('roles.staff');
            case UserRole.RECEPTIONIST:
                return t('roles.receptionist');
            case UserRole.ADMIN:
                return t('roles.admin');
            default:
                return t('roles.staff');
        }
    };

    return (
        <div className="header">
            {/* Hamburger button visible on desktop and mobile */}
            <button
                className="menu-toggle"
                onClick={toggleSidebar}
                aria-label="Toggle menu"
            >
                <span className="hamburger-icon-mobile">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </button>

            <div className="header-content">
                {currentUser ? (
                    <div className="welcome-section">
                        <div className="welcome-message">
                            <span className="welcome-text">{t('dashboard.greeting').split('{name}')[0]}</span>
                            <span className="user-name-highlight">{(currentUser.name || currentUser.username || '').split(' ')[0]}</span>
                        </div>
                        <div className="user-role-info">
                            <span className="role-badge">{getUserRoleText(currentUser.role)}</span>
                        </div>
                    </div>
                ) : (
                    <h1>{t('dashboard.stats.today') || 'Booking Management'}</h1>
                )}

                <div className="right-section" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
                    <NotificationBell />
                    <div className="lang-pill" style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: 'linear-gradient(135deg, #667eea, #764ba2)',
                        borderRadius: '9999px',
                        padding: '4px 14px',
                        color: 'white',
                        fontWeight: '700',
                        fontSize: '0.85rem',
                        letterSpacing: '0.5px',
                        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.4)'
                    }}>
                        <span 
                            onClick={() => setLanguage('vi')}
                            style={{ 
                                cursor: 'pointer', 
                                opacity: language === 'vi' ? 1 : 0.5,
                                borderBottom: language === 'vi' ? '2px solid white' : '2px solid transparent',
                                paddingBottom: '1px',
                                transition: 'all 0.2s'
                            }}>VN</span>
                        <span style={{ opacity: 0.6, fontSize: '0.8rem' }}>/</span>
                        <span 
                            onClick={() => setLanguage('en')}
                            style={{ 
                                cursor: 'pointer', 
                                opacity: language === 'en' ? 1 : 0.5,
                                borderBottom: language === 'en' ? '2px solid white' : '2px solid transparent',
                                paddingBottom: '1px',
                                transition: 'all 0.2s'
                            }}>EN</span>
                    </div>

                    {currentUser && (
                        <div className="user-profile-section">
                            <button className="user-profile-btn" style={{ padding: '4px 12px' }}>
                                <span className="user-avatar-small" style={{ overflow: 'hidden' }}>
                                    {currentUser.avatar ? (
                                        <img src={currentUser.avatar} alt="Avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    ) : (
                                        (currentUser.name || currentUser.username || "U").charAt(0).toUpperCase()
                                    )}
                                </span>
                                <span className="user-name-short">{(currentUser.name || currentUser.username || '').split(' ')[0]}</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TopBar;
